import {Color} from 'three';

const FLOOR_TINTS=['#d8bd93','#b3b0aa','#bd9e79','#f0e6d3','#81776c','#705440'];

/** An unselected floor uses the photograph and scanned floor donors. Decor
 * styling never selects a floor; only an explicit saved finish replaces it. */
export function photoFloorUniforms(finish:number|null|undefined,sampledColor:[number,number,number]){
 const style=finish??0;
 return {
  floorStyle:{value:style},
  floorTint:{value:style>0
   ?new Color(FLOOR_TINTS[(style-1)%FLOOR_TINTS.length]).convertSRGBToLinear()
   :new Color(...sampledColor).convertSRGBToLinear()},
 };
}
